<ng-template #template_usuario>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Editar usuario</h4>
    <button
      name="modalRef"
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="Close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formUsuario" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label for="firstName">Nombres:</label>
        <input
          type="text"
          class="form-control"
          id="firstName"
          formControlName="firstName"
          placeholder="Ingrese Nombres"
        />
      </div>

      <div class="mb-3">
        <label for="lastName">Apellidos:</label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          formControlName="lastName"
          placeholder="Ingrese Apellidos"
        />
      </div>

      <div class="mb-3">
        <label for="email">Email:</label>
        <input
          type="email"
          class="form-control"
          id="email"
          formControlName="email"
          placeholder="Ingrese Email"
        />
      </div>
      @if ( formUsuario.controls['email'].invalid &&
      formUsuario.controls['email'].touched ) {
      <p class="text-error-form-2">Debe Ingresar el correo correctamente.</p>
      }
      <div class="mb-3">
        <label for="username">Usuario:</label>
        <input
          type="text"
          class="form-control"
          id="username"
          formControlName="username"
          placeholder="Ingrese Nombre de Usuario"
        />
      </div>
      <div class="mb-3">
        <label for="phone">Celular:</label>
        <input
          type="phone"
          class="form-control"
          id="phone"
          formControlName="phone"
          placeholder="Ingrese Telefono"
          maxlength="12"
        />
      </div>
      @if ( formUsuario.controls['phone'].invalid &&
      formUsuario.controls['phone'].touched ) {
      <p class="text-error-form-2">Debe Ingresar Contacto</p>
      }

      <div class="mb-3">
        <label for="password">Contraseña:</label>
        <input
          type="password"
          class="form-control"
          id="password"
          formControlName="password"
          placeholder="Ingrese Contraseña"
        />
      </div>
      @if ( formUsuario.controls['password'].invalid &&
      formUsuario.controls['password'].touched ) {
      <p class="text-error-form-2">Debe Ingresar Contraseña</p>
      }
      <div class="mb-3">
        <label for="userRole">ROL</label>
        <select
          name="userRole"
          class="form-control"
          id="userRole"
          formControlName="userRole"
        >
          <option value="buyer">Comprador</option>
        </select>
      </div>
      @if ( formUsuario.controls['userRole'].invalid &&
      formUsuario.controls['userRole'].touched ) {
      <p class="text-error-form-2">Debe Ingresar Rol</p>
      }
      <button
        name="salir"
        type="button"
        class="btn btn-secondary"
        aria-label="Close"
        (click)="modalRef.hide(); formUser()"
        style="margin-right: 10px"
      >
        Salir
      </button>

      <button
        name="Actualizar"
        type="submit"
        class="btn btn-success"
        [disabled]="!formUsuario.valid"
      >
        Actualizar
      </button>
    </form>
  </div>
</ng-template>

<ng-template #template_crearusuario>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Crear usuario</h4>
    <button
      name="modalRef"
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="Close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formUsuario" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label for="firstName">Nombres:</label>
        <input
          type="text"
          class="form-control"
          id="firstName"
          formControlName="firstName"
          placeholder="Ingrese Nombres"
        />
      </div>
      <div class="mb-3">
        <label for="lastName">Apellidos:</label>
        <input
          type="text"
          class="form-control"
          id="lastName"
          formControlName="lastName"
          placeholder="Ingrese Apellidos"
        />
      </div>
      <div class="mb-3">
        <label for="email">Email:</label>
        <input
          type="email"
          class="form-control"
          id="email"
          formControlName="email"
          placeholder="Ingrese Email"
        />
      </div>
      @if ( formUsuario.controls['email'].invalid &&
      formUsuario.controls['email'].touched ) {
      <p class="text-error-form-2">Debe Ingresar el correo correctamente.</p>
      }
      <div class="mb-3">
        <label for="username">Usuario:</label>
        <input
          type="text"
          class="form-control"
          id="username"
          formControlName="username"
          placeholder=""
          [disabled]="true"
        />
      </div>
      <div class="mb-3">
        <label for="phone">Celular:</label>
        <input
          type="phone"
          class="form-control"
          id="phone"
          formControlName="phone"
          placeholder="Ingrese Telefono"
          maxlength="12"
        />
      </div>
      @if ( formUsuario.controls['phone'].invalid &&
      formUsuario.controls['phone'].touched ) {
      <p class="text-error-form-2">Debe Ingresar Celular</p>
      }

      <div class="mb-3">
        <label for="password">Contraseña:</label>
        <input
          type="password"
          class="form-control"
          id="password"
          formControlName="password"
          placeholder="Ingrese Contraseña"
        />
      </div>

      <div class="mb-3">
        <label for="userRole">ROL</label>
        <select
          name="userRole"
          class="form-control"
          id="userRole"
          formControlName="userRole"
        >
          <option value="buyer">Comprador</option>
        </select>
      </div>

      <button
        name="salir"
        type="button"
        class="btn btn-secondary"
        aria-label="Close"
        (click)="modalRef.hide(); formUser()"
        style="margin-right: 10px"
      >
        Salir
      </button>

      <button
        name="Crear"
        type="submit"
        class="btn btn-success"
        [disabled]="!formUsuario.valid"
      >
        Registrar
      </button>
    </form>
  </div>
</ng-template>

<ng-template #template_eliminarusuario>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Usuario</h4>
    <button
      name="modalRef"
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="Close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="alert alert-danger" role="alert">
      <i class="fas fa-info-circle" style="margin-right: 10px"></i> ¿Esta
      seguro que desea Eliminar a este usuario?
    </div>
    <hr />
    <div>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row">Usuario</th>
            <td>{{ users.username ? users.username : ('' | titlecase) }}</td>
          </tr>
          <tr>
            <th scope="row">Nombre</th>
            <td>
              {{ users.firstName | titlecase }}
              {{ users.lastName | titlecase }}
            </td>
          </tr>

          <tr>
            <th scope="row">Correo</th>
            <td>{{ users.email }}</td>
          </tr>
          <tr>
            <th scope="row">Contacto</th>
            @if (users.phone) {
            <td>{{ users.phone }}</td>
            } @if (!users.phone) {
            <td><font style="color: red">No tiene contacto</font></td>
            }
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-danger"
      aria-label="Close"
      (click)="Eliminar(users)"
    >
      Eliminar
    </button>
    <button
      type="button"
      class="btn btn-danger"
      aria-label="Close"
      (click)="Close()"
    >
      Cerrar
    </button>
  </div>
</ng-template>
